import { useQuery } from "@tanstack/react-query";
import { fetchAdminContacts } from "@/api/adminContacts";
import type { AdminContactListParams } from "@/interfaces/adminContacts";

/**
 * GET /admin/contacts, keyed by every param so distinct searches/filters/sorts/pages cache
 * independently. The filter dropdown lists ride along on this same response when the caller asks
 * for them -- there is no second endpoint and no second request.
 */
export function useAdminContacts(params?: AdminContactListParams) {
  return useQuery({
    queryKey: ["admin", "contacts", "list", params],
    queryFn: () => fetchAdminContacts(params),
  });
}
